import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";

import NotifyingExpertsSystemMessage from "./NotifyingExpertsSystemMessage";
import QuestionReroutedSystemMessage from "./QuestionReroutedSystemMessage";

class RejectedByUserBlockedQuestionSystemMessage extends Component {
    render() {
        const { message, question } = this.props;
        const messageActions = message.actions.map(({ link, text }) => ({
            label: text,
            intent: link,
        }));
        if (message.messageText) {
            return <QuestionReroutedSystemMessage messageActions={messageActions} messageText={message.messageText} />;
        }

        return <NotifyingExpertsSystemMessage question={question} />;
    }
}

RejectedByUserBlockedQuestionSystemMessage.propTypes = {
    question: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired,
};

export default RejectedByUserBlockedQuestionSystemMessage;
